<template>
  <div class="hello">
    <van-overlay :show="show">
      <div class="wrapper">
        <van-loading type="spinner" color="#1989fa" vertical>
          加载中...
        </van-loading>
      </div>
    </van-overlay>
    <showpdf v-if="showPdf" @close='closePdf()' :url="pdfFile"></showpdf>
    <div class="label" v-if="option1.length > 0">
      <span class="label_text">行业标签:</span>
      <van-dropdown-menu class="label_dropdown">
        <van-dropdown-item v-model="value1" :options="option1" @change="changeOption" />
      </van-dropdown-menu>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell class="content" v-for="(item, index) in list" :key="index">
        <div class="item">
          <div>
            <i class="iconfont icon-baogao"></i>
          </div>
          <ul>
            <li>日刊</li>
            <li>{{ moment(item.date).format('YYYY-MM-DD HH:mm:ss') }}</li>
          </ul>
        </div>
        <div class="content_text">
          <div class="content_text_title">
            <span class="content_text_title_text" v-html="item.title">
            </span>
            <span class="content_text_title_more" @click="openFile(item.newsUrl)"> ></span>
          </div>
          <div class="content_text_text" v-html="item.article">
          </div>
        </div>
        <div class="content_more" @click="openFile(item.newsUrl)">
          立即查看
        </div>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import { industryLabel, hotNews, getPdf } from '@/api/index'
import moment from 'moment';
import showpdf from './pdf/index'
export default {
  components: {
    showpdf
  },
  data() {
    return {
      value1: '全部',
      option1: [],
      time: '',
      loading: false,
      finished: false,
      list: [],
      pageNum: 1,
      pageSize: 10,
      showPdf: false,
      pdfFile: "",
      show: false,
    }
  },
  mounted() {
    // 获取浏览器url中的id参数
    // 获取数据
    this.getIndustryLabel()
  },
  methods: {
    moment,
    getIndustryLabel() {
      industryLabel().then(res => {
        res.unshift('全部')
        this.option1 = res.map(item => {
          return { text: item, value: item }
        })
        console.log(this.option1)
      })
    },
    // 查询每日热点
    onLoad() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        tag: this.value1 === '全部' ? null : this.value1,
      }
      hotNews(params).then(res => {
        this.list = this.list.concat(res.dataList.content);
        this.loading = false;
        if (res.dataList.content.length < this.pageSize) {
          this.finished = true;
        } else {
          this.pageNum++;
        }
      })
    },
    toDetail(url) {
      window.open()
    },

    changeOption() {
      this.pageNum = 1,
        this.list = [],
        this.finished = false,
        this.loading = true,
        this.onLoad()
    },
    closePdf() {
      this.showPdf = false
    },
    openFile(val) {
      this.show = true
      getPdf({ fileName: val }).then(res => {
        this.pdfFile = res
        this.showPdf = true
        this.show = false
      }).catch(err => {
        console.log(err)
        this.show = false
        this.$toast.fail('加载失败')
      })
    },



  }
}
</script>
<style lang="less" scoped>
.hello {
  background: #eef1f4;
  min-height: 98vh;

  .label {
    display: flex;
    padding: .1rem;

    &_text {
      width: 20%;
      line-height: 48px;
    }

    &_dropdown {
      width: 40%;
    }
  }

  .iconfont {
    font-size: .5rem;
    color: #ed9b3c;
    margin-top: 0.15rem;
    display: inline-block;
  }

  .content {
    background: #fff;
    padding: .1rem;
    margin-top: .1rem;

    .item {
      display: flex;

      ul {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: .2rem;
      }
    }

    &_text {
      margin-top: .2rem;
      line-height: 1.5;
      // 背景颜色从左到右渐变
      background: linear-gradient(to right, #efaf26, #eb8220);
      color: #fff;
      border-radius: 0.1rem;
      padding: .1rem;
      position: relative;

      &_title {
        font-size: .16rem;

        &_text {
          display: inline-block;
          width: 90%;
          // 溢出显示省略号
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &_more {
          width: 10%;
          text-align: right;
          position: absolute;
          color: #605c5c;

        }
      }

      &_text {
        // 内容超出2行显示省略号
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    &_more {
      margin-top: .2rem;
      font-size: .16rem;
      text-align: center;
      display: block;
      color: #605c5c;
    }
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>